import React, { useEffect, useRef, useState } from "react";
import CompanyProfileComponent from "../components/CompanyProfileComponent";
import HomeContainer from "./HomeContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  getUploadCompanyProfileLogo,
  postUploadCompanyProfileLogo,
} from "../store/actions";

const CompanyProfileContainer = () => {
  const [dragActive, setDragActive] = useState(false);
  const [image, setImage] = useState(null);
  const [activeEmployees, setActiveEmployees] = useState(0);
  const [availableLicences, setAvailableLicences] = useState(0);
  const [totalLicences, setTotalLicences] = useState(0);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const fecthGetCompanyLogoData = useSelector(
    (state) => state.fecthGetCompanyLogoData
  );
  const fecthPostCompanyLogoData = useSelector(
    (state) => state.fecthPostCompanyLogoData
  );

  useEffect(() => {
    dispatch(getUploadCompanyProfileLogo());
  }, []);
  useEffect(() => {
    if (fecthGetCompanyLogoData && fecthGetCompanyLogoData?.data) {
      if (
        fecthGetCompanyLogoData?.data[0] &&
        fecthGetCompanyLogoData?.data[0]?.file_url
      ) {
        setImage(fecthGetCompanyLogoData?.data[0]?.file_url);
      }
      setActiveEmployees(fecthGetCompanyLogoData?.active_employees);
      setAvailableLicences(fecthGetCompanyLogoData?.available_licences);
      setTotalLicences(fecthGetCompanyLogoData?.total_licences);
    }
  }, [fecthGetCompanyLogoData]);
  useEffect(() => {
    if (fecthPostCompanyLogoData && fecthPostCompanyLogoData?.data) {
      setImage(fecthPostCompanyLogoData?.data);
    }
  }, [fecthPostCompanyLogoData]);
  const onButtonClick = () => {
    inputRef.current.click();
  };

  const handleFile = (file) => {
    if (file && file.type.startsWith("image/")) {
      setImage(URL.createObjectURL(file));
      dispatch(postUploadCompanyProfileLogo(file));
    } else {
      alert("Please upload an image file.");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    if (e.target.files.length > 0) {
      handleFile(e.target.files[0]);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave" || e.type === "drop") {
      setDragActive(false);
    }
  };
  const content = (
    <>
      <CompanyProfileComponent
        dragActive={dragActive}
        image={image}
        onButtonClick={onButtonClick}
        handleDrop={handleDrop}
        handleChange={handleChange}
        handleDrag={handleDrag}
        inputRef={inputRef}
        activeEmployees={activeEmployees}
        availableLicences={availableLicences}
        totalLicences={totalLicences}
      />
    </>
  );
  return <HomeContainer content={content} />;
};

export default CompanyProfileContainer;
